import React from 'react'
import { useSelector } from 'react-redux'

import {
  selectUserSecondariesSubscriptionInfo,
  selectUserSubscriptionInfo,
} from 'root-redux/selects/user'

import { ExtraSubscription } from './ExtraSubscription'
import { InAppPurchases } from './InAppPurchases'
import { StyledPianoSubscriptions as S } from './PianoSubscriptions.styles'
import { SecondarySubscription } from './SecondarySubscription'
import { Subscriptions } from './Subscriptions'

type TProps = {
  onRequestWithdrawal: (subscriptionId: string, contract: string) => void
}

export const PianoSubscriptions: React.FC<TProps> = ({
  onRequestWithdrawal,
}) => {
  const userSubscriptionInfo = useSelector(selectUserSubscriptionInfo)
  const userSecondarySubscriptions = useSelector(
    selectUserSecondariesSubscriptionInfo,
  )

  if (!userSubscriptionInfo) {
    return null
  }

  return (
    <>
      <Subscriptions onRequestWithdrawal={onRequestWithdrawal} />

      <S.AdditionalSubscriptions>
        {userSecondarySubscriptions.map((subscription) => (
          <SecondarySubscription
            key={subscription.subscriptionId}
            secondarySubscription={subscription}
            onRequestWithdrawal={onRequestWithdrawal}
          />
        ))}

        {userSubscriptionInfo.extras?.map((extra) => (
          <ExtraSubscription key={extra.id} extra={extra} />
        ))}
        <InAppPurchases />
      </S.AdditionalSubscriptions>
    </>
  )
}
